import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Screen } from '../../components/Screen'; // Adjust the import path as needed
import {
  getContentfulArticleCards,
  getContentfulRecipeCards,
  getContentfulVideoCards,
} from '../../lib/contentful/getContentfulContent';
import { DetailView } from './components/DetailView';
import { FilterableView } from './components/FilterableView';
import { Section } from './components/Section';

const LearningCenterScreen = () => {
  // Demo data arrays with image URLs
  const [guidebooks, setGuidebooks] = useState([]);
  const [recipes, setRecipes] = useState([]);
  const [videos, setVideos] = useState([]);
  const [articles, setArticles] = useState([]);
  const params = useParams();
  const location = useLocation();

  useEffect(() => {
    //getContentfulGuidebookCards().then(setGuidebooks).catch(console.error);
    getContentfulRecipeCards().then(setRecipes).catch(console.error);
    getContentfulVideoCards().then(setVideos).catch(console.error);
    getContentfulArticleCards().then(setArticles).catch(console.error);
  }, []);

  if (params.slug) {
    if (params.category === 'videos') {
      return (
        <DetailView
          type="video"
          slug={params.slug}
        />
      );
    } else if (params.category === 'recipes') {
      return (
        <DetailView
          type="recipe"
          slug={params.slug}
        />
      );
    } else if (params.category === 'articles') {
      return (
        <DetailView
          type="article"
          slug={params.slug}
        />
      );
    }
  }

  if (location.pathname === '/learn/guidebooks') {
    return (
      <Screen
        title={'Challenge Guidebooks'}
        showSidebarNav={true}
        admin={true}
      >
        <FilterableView
          title="Challenge Guidebooks"
          viewAllPath="/learn/guidebooks"
          data={guidebooks}
        />
      </Screen>
    );
  }

  if (location.pathname === '/learn/articles') {
    return (
      <Screen
        title={'Articles'}
        showSidebarNav={true}
        admin={true}
      >
        <FilterableView
          title="Articles"
          viewAllPath="/learn/articles"
          data={articles}
        />
      </Screen>
    );
  }

  if (location.pathname === '/learn/videos') {
    return (
      <Screen
        title={'Videos'}
        showSidebarNav={true}
        admin={true}
      >
        <FilterableView
          title="Videos"
          viewAllPath="/learn/videos"
          data={videos}
        />
      </Screen>
    );
  }

  if (location.pathname === '/learn/recipes') {
    return (
      <Screen
        title={'Recipes'}
        showSidebarNav={true}
        admin={true}
      >
        <FilterableView
          title="Recipes"
          viewAllPath="/learn/recipes"
          data={recipes}
        />
      </Screen>
    );
  }

  // Default display if no specific viewAllPath is active
  return (
    <Screen
      title={'Learning Center'}
      showSidebarNav={true}
      admin={true}
    >
      <Box sx={{ padding: '30px' }}>
        {/*<Section title="Challenge Guidebooks" viewAllPath="/learn/guidebooks" data={guidebooks} />*/}
        <Section
          title="Articles"
          viewAllPath="/learn/articles"
          data={articles.slice(0, 4)}
        />
        <Section
          title="Videos"
          viewAllPath="/learn/videos"
          data={videos.slice(0, 4)}
        />
        <Section
          title="Recipes"
          viewAllPath="/learn/recipes"
          data={recipes.slice(0, 4)}
        />
      </Box>
    </Screen>
  );
};

export default LearningCenterScreen;
